import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { getRadiantV2Tokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { LENDING_POOL_ADDRESSES } from '../constants';
export var SwapBorrowRateMode = createPlugin({
    protocol: 'RADIANTV2',
    type: 'ACTION',
    method: 'swapBorrowRateMode',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'radiant_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getRadiantV2Tokens({ chainId: chainId }) }),
                    rateMode: new FctValue({
                        options: [
                            { value: '1', name: 'Stable' },
                            { value: '2', name: 'Variable' },
                        ],
                    }),
                },
            },
            output: {},
        });
    },
});
